// extracted by mini-css-extract-plugin
export default {"containerLinks":"SideMenu_containerLinks__FgEqO"};